import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as websiteTagsAction from '../actions/website-tags.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadWebsiteTags} from '../actions';
import {WebsiteService} from "../../websites/website.service";
import {WebsiteTag} from "../../websites/website/website-tag";
import {WebsiteTagMapper} from "../../websites/website/website-tag-mapper";

@Injectable()
export class WebsiteTagsEffects {

  loadWebsiteTags$ = createEffect(() => this._actions$.pipe(
    ofType(websiteTagsAction.LOAD_WEBSITE_TAGS),
    mergeMap((action: LoadWebsiteTags) => {
      return this._websiteService.getUserTags()
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              const tagsList = response.data
                .filter((websiteTag: WebsiteTag) => typeof websiteTag.id === 'number' && websiteTag.title !== '')
                .map((website) => WebsiteTagMapper.map(website));
              return new websiteTagsAction.LoadWebsiteTagsSuccess(tagsList);
            }
            return new websiteTagsAction.LoadWebsiteTagsFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _websiteService: WebsiteService
  ) {
  }

}
